import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

import { queryClient } from '@/lib/query-client';
import { clearAuthState } from '@/stores/auth.store';

import { logout } from '../api/auth.api';

export function useLogout() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: () => logout(),
    onSuccess: () => {
      clearAuthState();
      queryClient.clear();
      toast.success('Logged out successfully');
      navigate({ to: '/login' });
    },
    onError: () => {
      // Even on error, clear local state
      clearAuthState();
      queryClient.clear();
      navigate({ to: '/login' });
    },
  });
}
